import { ApiURL } from "./services/apiConstants";
import {
  clearAllEntries,
  deleteDatabase,
  deleteEntry,
  getAllEntries,
  updateEntry,
} from "./services/indexedDBService";
import { post } from "./services/services";

export function register(config) {
  const isEnvSupported =
    process.env.REACT_APP_MODE === "development" ||
    process.env.NODE_ENV === "production";
  if ("serviceWorker" in navigator && isEnvSupported) {
    window.addEventListener("load", () => {
      const swUrl = `${process.env.PUBLIC_URL}/sw.js`;
      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          // console.log("✅ Service Worker registered with scope:", registration.scope);
          if (config && config.onUpdate) {
            registration.onupdatefound = () => {
              const installingWorker = registration.installing;
              if (installingWorker) {
                installingWorker.onstatechange = () => {
                  if (installingWorker.state === "installed") {
                    if (navigator.serviceWorker.controller) {
                      // console.log("⚠️ New content is available; please refresh.");
                      config.onUpdate(registration);
                    } else {
                      // console.log("📦 Content is cached for offline use.");
                    }
                  }
                };
              }
            };
          }
        })
        .catch((error) => {
          console.error("❌ Service Worker registration failed:", error);
        });
    });

    window.addEventListener("online", async () => {
      try {
        const offlineEntries = await getAllEntries();
        for (const entry of offlineEntries) {
          if (!entry.sync_pending) continue;
          const FORM_DATA = new FormData();
          Object.entries(entry).forEach(([key, value]) => {
            if (key !== "timestamp" && key !== "sync_pending") {
              FORM_DATA.append(key, value);
            }
          });
          try {
            const res = await post(ApiURL.add_eng_log_basic_st, FORM_DATA);
            if (res?.status === true) {
              // ✅ Mark entry as synced
              await updateEntry(entry.id, { ...entry, sync_pending: false });
            }
          } catch (err) {
            console.error(`❌ Failed to sync entry ID: ${entry.id}`, err);
          }
        }

        // ✅ Optional: remove all synced entries
        const remaining = await getAllEntries();
        const synced = remaining.filter((e) => e.sync_pending === false);
        for (const entry of synced) {
          await deleteEntry(entry.id); // or await clearAllEntries() if you want to remove all
        }
        console.log("✅ All entries synced successfully.");
      } catch (err) {
        console.error("❌ Sync failed:", err);
      }
    });
  } else {
    console.log(
      "⚠️ Service Worker not registered: Unsupported environment or browser."
    );
  }
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => {
        for (const registration of registrations) {
          registration.unregister();
        }
      })
      .catch((error) => {
        console.error("❌ Service Worker unregistration failed:", error);
      });
  } else {
    console.warn("⚠️ Service Worker not supported in this browser.");
  }
}
